// ============================================================
// Wordmark — "WFS Chatbot" lockup
//
// A real brand mark + wordmark + badge:
//   [▦] WFS [Chatbot]
//
// The mark is a 28px rounded square with a 2x2 dot grid inside,
// hinting at "individual stones bound into one surface" (the
// parent brand metaphor) without being literal. The "AI" is a
// signal-mint pill, locked at small size, anchored to the right
// of the wordmark.
// ============================================================

interface Props {
  className?: string;
  inverted?: boolean;
  /** Show the brand mark to the left of the wordmark. Default true. */
  withMark?: boolean;
}

export default function Wordmark({ className = '', inverted = true, withMark = true }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      aria-label="WFS Chatbot"
    >
      {withMark && <BrandMark />}
      <span className="font-bold tracking-headline-tight leading-none text-white">
        WFS
      </span>
      <span
        className="inline-flex items-center rounded-[5px] px-1.5 py-[3px] font-mono text-[0.625rem] font-semibold uppercase leading-none tracking-mono"
        style={{ background: '#7CFFB8', color: '#0E1316' }}
      >
        Chatbot
      </span>
    </span>
  );
}

/** The little square brand mark. Reusable wherever we want a parent-brand cue. */
export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <span
      className="relative flex shrink-0 items-center justify-center rounded-md border border-signal/30 bg-ink-2"
      style={{ width: size, height: size }}
      aria-hidden
    >
      {/* gradient signal glow */}
      <span
        className="absolute inset-0 rounded-md opacity-40"
        style={{
          background:
            'linear-gradient(135deg, rgba(124,255,184,0.18), transparent 60%)',
        }}
      />
      {/* 2x2 dot grid — "stones bound together" */}
      <span className="relative grid grid-cols-2 gap-[3px]">
        <span className="h-[3px] w-[3px] rounded-full" style={{ background: '#7CFFB8' }} />
        <span className="h-[3px] w-[3px] rounded-full" style={{ background: '#7CFFB8', opacity: 0.55 }} />
        <span className="h-[3px] w-[3px] rounded-full" style={{ background: '#7CFFB8', opacity: 0.55 }} />
        <span className="h-[3px] w-[3px] rounded-full" style={{ background: '#7CFFB8' }} />
      </span>
    </span>
  );
}
